import { GAME_PHASES } from '@texas42/game-runtime';
import type { GameSessionView, SharePolicy } from './types.js';

const REPLAY_LABEL = 'Completed hand replay — includes full action history';

/**
 * Active deals must not be shared with deterministic seeds or initial hands.
 * Replay links are allowed only after a hand or match completes.
 */
export function evaluateSharePolicy(view: GameSessionView): SharePolicy {
  const phase = view.gameState.phase;

  if (
    phase === GAME_PHASES.SCORING ||
    phase === GAME_PHASES.GAME_END ||
    phase === GAME_PHASES.ONE_HAND_COMPLETE
  ) {
    return { allowed: true, kind: 'replay', label: REPLAY_LABEL };
  }

  return {
    allowed: false,
    reason: 'Sharing is available after the current hand or match completes.',
  };
}
